import React, { memo } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { CommonProperties, Color } from '../../styles';
import BaseText from '../BaseText';
import ListControl from './ListControl';

const SegmentItem = ({ selected, label, ...rest }) => {
  return (
    <TouchableOpacity
      style={[segmentItemStyle.itemSegmented, selected && segmentItemStyle.selected]}
      {...rest}
    >
      <BaseText
        style={[
          segmentItemStyle.text,
          selected ? segmentItemStyle.primaryText : segmentItemStyle.secondText,
        ]}
      >
        {label}
      </BaseText>
    </TouchableOpacity>
  );
};

const SegmentedHeader = memo(({ items, selected, onChange, ...rest }) => {
  return (
    <ListControl
      items={items}
      renderItem={(item, index) => (
        <SegmentItem
          key={index}
          onPress={() => onChange(item.value)}
          selected={item.value === selected}
          label={item.label}
        />
      )}
      {...rest}
    />
  );
});

const segmentItemStyle = StyleSheet.create({
  itemSegmented: {
    flex: 1,
    borderLeftWidth: 0.5,
    borderLeftColor: Color.gray,
    ...CommonProperties.py2,
  },
  text: {
    textAlign: 'center',
    flexWrap: 'wrap',
    ...CommonProperties.h4,
  },
  primaryText: {
    color: 'white',
  },
  secondText: {
    color: Color.primary,
  },
  selected: {
    backgroundColor: Color.active,
  },
});

export default SegmentedHeader;
